import React from 'react';
import {translate} from 'utils/common';
import {setCookie, getCookie} from 'utils/cookie';
import {LANG_SWITCHED,LANG} from 'utils/constants';
import en from 'assets/images/en.svg';
import th from 'assets/images/th.svg';
import { Dropdown, DropdownToggle, DropdownMenu } from 'reactstrap';
import dataService from 'utils/dataservice';
class LanguageSwitch extends React.Component{
    constructor(props) {
        super(props);
        this.switchLanguage = this.switchLanguage.bind(this);
        this.toggleLang = this.toggleLang.bind(this);
        this.state={value:this.props.value ? this.props.value:'', isLangOpen: false, lang: app.selectedLocale}
    }
    toggleLang() {
        this.setState(p => ({ isLangOpen: !p.isLangOpen }));
    }
    switchLanguage(event){
        let lang = event.currentTarget.attributes.value.value;
        if (this.state.lang != lang) {
            this.setState({ isLangOpen: false, lang });
            // setCookie(LANG, lang);
            app.events.trigger(LANG_SWITCHED, lang);
            
            app.userAuth.userId && dataService.putRequest('userUpdate', { userId: app.userAuth.userId, preferredLanguage: lang }).then(res => {
                res && (app.userAuth.preferredLanguage = res.preferredLanguage);
            }).catch(res => {
                //this.handleError(res.error,res.errorCode);
            });
            

            dataService.getRequest('getSupplierInfo', { userId: app.userAuth.userId, preferredLanguage: lang }).then(res=>{
                app.userAuth.contactShopName = res.shopName;
            }).catch(error => {
               }
            );

            }
    }
    render(){
        return(           
                <Dropdown isOpen={this.state.isLangOpen} toggle={this.toggleLang}>
                    <DropdownToggle caret tag="a" className="btn dropdown-toggle">
                    <span className="items-wrap"><img className="" src={this.state.lang == 'en' ? en : th} alt={this.state.lang}/></span>
                    <span className="items-text">{translate("lang." + this.state.lang)}</span>
                    </DropdownToggle>
                    <DropdownMenu tag="ul" className="p-3 dropdown-menu-center account-types">
                        <React.Fragment>
                            {app.locales.map(lang =>
                                <li className={this.state.lang == lang ? 'active' : ''} key={lang} value={lang} onClick={this.switchLanguage}>
                                    <img className="mr-2" src={lang == 'en' ? en : th} alt={lang}/><span>{translate("lang." + lang)}</span>
                                </li>)}
                        </React.Fragment>
                    </DropdownMenu>
                </Dropdown>
            
            // <select name={this.props.name} className="custom-select form-control" onChange={this.switchLanguage} 
            // value={this.state.value}>
            //     {app.locales.map(lang=><option key={lang} value={lang}>{translate("lang."+lang)}</option>)}
            // </select>
        )
    }
}
LanguageSwitch.defaultProps = {
    triggerEventOnChange: true
}
export default LanguageSwitch;